import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { publicLoginSaga } from './saga';
import { ILoginVersion, PublicLoginState } from './types';

export const initialState: PublicLoginState = {
  getVersion: {
    loading: false,
    success: false,
    data: undefined,
    error: undefined,
  },
};

const slice = createSlice({
  name: 'publicLogin',
  initialState,
  reducers: {
    getVersion(state) {
      state.getVersion.loading = true;
      state.getVersion.success = false;
    },
    getVersionSuccess(state, action: PayloadAction<ILoginVersion>) {
      state.getVersion.loading = false;
      state.getVersion.success = true;
      state.getVersion.data = action.payload;
    },
    getVersionFailed(state, action: PayloadAction<any>) {
      state.getVersion.loading = false;
      state.getVersion.success = false;
      state.getVersion.data = undefined;
      state.getVersion.error = action.payload;
    },
  },
});

export const { actions: publicLoginActions } = slice;

export const usePublicLoginSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: publicLoginSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = usePublicLoginSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
